import React from "react";
import { chakra, Tooltip } from "@chakra-ui/react";

import { FaDiscord } from "react-icons/fa";

export default function ButtonInvite() {
  const language = localStorage.getItem("language");

  const newLanguage = require(`language/${language}.json`);

  return (
    <Tooltip label="Convide o Tanjiro para o seu Servidor." placement="auto">
      <chakra.a
        position="fixed"
        right="10"
        top="45%"
        background="white"
        fontSize="13pt"
        color="black"
        width="100px"
        height="100px"
        borderRadius="50px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        cursor="pointer"
        href="https://dsc.gg/tanjirobot"
        target="_blank"
      >
        <FaDiscord color="#333" size={25} /> {newLanguage.invite}
      </chakra.a>
    </Tooltip>
  );
}
